/**
 * <pricing-tier-picker>
 * Same idea as <pack-selector>: renders one product option as styled rows
 * instead of the native picker. Selecting a row proxy-clicks the real
 * (hidden) native variant-picker input for that option/value, so variant
 * switching, price updates and add-to-cart stay fully native.
 */
class PricingTierPicker extends HTMLElement {
  connectedCallback() {
    this.optionName = this.dataset.optionName || '';
    this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
    if (!this.tiers.length) return;

    this.tiers.forEach((tier) => {
      tier.addEventListener('click', () => this.select(tier));
    });
  }

  select(tier) {
    const nativeInput = this.findNativeVariantInput(tier.dataset.packValue);
    if (!nativeInput) return;

    // Real .click() (not manual checked+change) so the native click -> input
    // -> change sequence fires exactly as a genuine interaction would.
    nativeInput.click();

    this.tiers.forEach((t) => {
      const isSelected = t === tier;
      t.classList.toggle('is-selected', isSelected);
      t.setAttribute('aria-checked', isSelected);
    });
  }

  findNativeVariantInput(value) {
    const inputs = document.querySelectorAll(`input[data-option-name="${CSS.escape(this.optionName)}"]`);
    return Array.from(inputs).find((input) => input.value === value);
  }
}

if (!customElements.get('pricing-tier-picker')) {
  customElements.define('pricing-tier-picker', PricingTierPicker);
}
